module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.back($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('v-layout', {
    attrs: {
      "align-top": ""
    }
  }, [_c('h2', {
    staticClass: "modal__title title--general title--2"
  }, [_c('div', [_vm._v("Change")]), _vm._v(" "), _c('div', [_vm._v("billing details")])]), _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": _vm.back
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)])], 1), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('form', {
    staticClass: "modal__section",
    class: {
      'has-error': _vm.errors.any()
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.changeBillingAddress($event)
      }
    }
  }, [_c('billing-fields', {
    attrs: {
      "wrapperClass": "constrain",
      "parent": _vm.vue,
      "defaultValues": _vm.billingAddress,
      "enableVatCalculating": false
    },
    on: {
      "billingPayload": _vm.billingPayload
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "type": "submit",
      "loading": _vm.isSaving,
      "disabled": _vm.isSaving,
      "color": "primary"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tSave settings\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('apierror')),
      expression: "errors.has('apierror')"
    }],
    staticClass: "input-field__error"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('apierror')) + " ")])], 1)]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16eef7a6","hasScoped":false}!./app/components/account-billing-modal/template.html
// module id = 372
// module chunks = 0